import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="footer-container">
        {/* Left Section */}
        <div className="footer-left">
          <h2 className="footer-title">SAMMARSHYA</h2>
          <p className="footer-text">
            Sammarshya — software product development services.
          </p>
          <div className="social-icons">
            <a href="/" target="_blank">
              <i className="fa-brands fa-linkedin"></i>
            </a>
            <a href="/" target="_blank">
              <i className="fa-brands fa-facebook-f"></i>
            </a>
            <a href="/" target="_blank">
              <i className="fa-brands fa-twitter"></i>
            </a>
            <a href="/" target="_blank">
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="/" target="_blank">
              <i className="fa-brands fa-behance"></i>
            </a>
          </div>
        </div>

        {/* Middle Section */}
        <div className="footer-middle">
          <h3 className="footer-heading">Consulting</h3>
          <ul className="footer-list">
            <li>Discovery Phase</li>
            <li>Technology Consulting</li>
            <li>IT Audit Services</li>
          </ul>
          <h3 className="footer-heading">Product Design</h3>
          <ul className="footer-list">
            <li>Product Experience Design</li>
            <li>Business Analysis</li>
          </ul>
        </div>

        {/* Right Section */}
        <div className="footer-right">
          <h3 className="footer-heading">Services</h3>
          <ul className="footer-list">
            <li>Evaluation & Design</li>
            <li>Custom Software</li>
            <li>Web Development</li>
            <li>Mobile Development</li>
            <li>Maintenance & Support</li>
            <li>Cloud Infrastructure</li>
          </ul>
        </div>

        {/* About Section */}
        <div className="footer-about">
          <h3 className="footer-heading">About us</h3>
          <ul className="footer-list">
            <li>About us</li>
            <li>Case Studies</li>
          </ul>
          <h3 className="footer-heading">Contact us</h3>
          <ul className="footer-list">
            <li>✆ +91-9552461202</li>
            
            <li>📧 contact@sammarshya.com </li>
            <li>⚲ <a className="footer-add"
                href="https://maps.app.goo.gl/ut2M2JbSthivT6wW7"
                target="_blank"
                rel="noopener noreferrer"
               
              >  B-Wing, 2nd Floor, Montclaire, India Accelerato, near, Baner - Pashan Link Rd, Baner, Pune, Maharashtra 411021 </a> <br /></li>
          </ul>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p className="footer-bottom-text">PRIVACY POLICY | SITEMAP</p>
        <p className="footer-bottom-text">
          © 2023 SAMMARSHYA | POWERED BY ONECONTRIBUTOR
        </p>
      </div>
    </div>
  );
}

export default Footer;
